import React, { useContext, useEffect, useRef, useState } from 'react'
import Layout from '../../../Layout/Layout'
import { useLocation, useParams } from 'react-router'
import { addQuestion, fetchQuizQuestions, updateQuestion, uploadImage } from '../../../firebase/utils'
import Select from 'react-select';
import { validateData } from '../../../utils/validate'
import QuizContext from '../../../Helper/Quiz'
import CommonModal from "../../UiKits/Modals/common/modal";
import ImagecropperContain from "../../BonusUi/ImageCropper";
import Loader from '../../../Layout/Loader'
import { Card, Col, Container, Form, Input, Label, Row } from 'reactstrap'
import { Breadcrumbs, Btn, P } from '../../../AbstractElements'
import { Edit, X, XCircle } from 'react-feather'
import UploadImageContain from '../../BonusUi/ImageUpload';
import Sidebar from '../../../Layout/Sidebar/Sidebar';
import { toast } from 'react-toastify';

const QuizQuestions = () => {
  const { fetchQuiz, quiz, loading, questionNo, setQuestionNo, addQuiz, setAddQuiz, setQuiz } = useContext(QuizContext)
  const [quizInfo, setQuizInfo] = useState(null)
  const [isEditable, setIsEditable] = useState(false)
  const [files, setFiles] = useState([])
  const [loader, setLoader] = useState(false)
  const imageCanvasRef = useRef(null)
  const [cropper, setCropper] = useState({
    show: false,
    url: ''
  })
  const { pathname } = useLocation()
  const quizIdRegex = /\/quiz\/([^\/]+)/;
  const questionIdRegex = /\/questions\/([^\/]+)/;

  const fetchQuestions = async () => {
    if (!quizIdMatch || !questionIdMatch) return
    await fetchQuiz(quizIdMatch, questionIdMatch)

  }

  // Extract the IDs using match method
  const quizIdMatch = pathname.match(quizIdRegex)[1];
  const questionIdMatch = pathname.match(questionIdRegex)[1];
  const optionChangeHandler = (value, name) => {
    setQuizInfo({
      ...quizInfo,
      [name]: value,
    })
  }

  const close = () => {
    if (addQuiz) setAddQuiz(false)
    else if (isEditable) setIsEditable(false)
    else setQuestionNo(prev => prev - 1)
  }
  const closeCropper = () => setCropper({
    show: false,
    urll: ''
  })

  const cropComplete = () => {
    const canvas = imageCanvasRef.current;
    const dataURL = canvas?.toDataURL(); // This will give you a Base64 encoded string
    setQuizInfo({
      ...quizInfo,
      imageUrl: dataURL
    })

    closeCropper()
  }
  const updateQuestionHandler = async () => {


    let url;
    let newQuestion = {};
    const correctName = {
      [quizInfo.option1]: 'A',
      [quizInfo.option2]: 'B',
      [quizInfo.option3]: 'C',
      [quizInfo.option4]: 'D'
    }
    newQuestion.correct_answer = { value: quizInfo.correctOption, name: correctName[quizInfo.correctOption] }
    newQuestion.question = quizInfo.question;
    newQuestion.questions = {
      A: { value: quizInfo.option1, name: 'A' },
      B: { value: quizInfo.option2, name: 'B' },
      C: { value: quizInfo.option3, name: 'C' },
      D: { value: quizInfo.option4, name: 'D' },
    };
    if (validateData(newQuestion)) {
      setLoader(true)
      if (quizInfo?.imageUrl?.includes("data:")) {
        url = await uploadImage(quizInfo.imageUrl, 'images/')
      }
      if (url) {
        newQuestion.imageUrl = url
      } else if (quizInfo.imageUrl) {
        newQuestion.imageUrl = quizInfo.imageUrl
      }
      const allQuestion = quiz.questions.map((quiz, index) => index === questionNo ? newQuestion : quiz);
      setQuiz({
        questions: allQuestion
      })
      setQuizInfo({
        ...quizInfo,
        option1: newQuestion.questions.A.value,
        option2: newQuestion.questions.B.value,
        option3: newQuestion.questions.C.value,
        option4: newQuestion.questions.D.value,
        correctOption: newQuestion.correct_answer.value,
        imageUrl: newQuestion.imageUrl
      })
      await updateQuestion(allQuestion, quizIdMatch, questionIdMatch)
      fetchQuestions()
      toast.success('Question updated successfully')
      setLoader(false)
      setIsEditable(false)

    } else {
      toast.error('Please enter all the fields')
    }
  }

  const closeImageCropper = () => {
    setQuizInfo({
      ...quizInfo,
      imageUrl: cropper.url
    })
    closeCropper()

  }

  const createQuizQuestion = async () => {

    let url;
    let newQuestion = {};
    const correctName = {
      [quizInfo.option1]: 'A',
      [quizInfo.option2]: 'B',
      [quizInfo.option3]: 'C',
      [quizInfo.option4]: 'D'
    }
    newQuestion.correct_answer = { value: quizInfo.correctOption, name: correctName[quizInfo.correctOption] }
    newQuestion.question = quizInfo.question;
    newQuestion.questions = {
      A: { value: quizInfo.option1, name: 'A' },
      B: { value: quizInfo.option2, name: 'B' },
      C: { value: quizInfo.option3, name: 'C' },
      D: { value: quizInfo.option4, name: 'D' },
    };
    if (validateData(newQuestion)) {
      setLoader(true)
      if (quizInfo?.imageUrl?.includes("data:")) {
        url = await uploadImage(quizInfo.imageUrl, 'images/')
      }
      if (url) {
        newQuestion.imageUrl = url
      }
      if (!quiz?.questions?.length) {
        quiz.questions = []
      }
      quiz.questions.push(newQuestion)

      addQuestion(quiz.questions, quizIdMatch, questionIdMatch)
      toast.success('Question added successfully')
      fetchQuestions()
      setLoader(false)
      setQuestionNo(quiz.questions.length - 1)
      setAddQuiz(false)

    } else {
      toast.error('Please enter all the fields')
    }
  }

  const update = () => {
    console.log('here')
    if (isEditable) {
      updateQuestionHandler()
    } else if (addQuiz) {
      createQuizQuestion()
    } else {
      setQuestionNo(prev => prev + 1)
    }
  }

  const imageChangeHandler = ({ target }) => {
    const reader = new FileReader();
    reader.onload = () => {
      setCropper({
        show: true,
        url: reader.result
      })
    };
    reader.readAsDataURL(target.files[0]);
  }

  useEffect(() => {
    const curr = quiz && quiz?.questions && quiz?.questions[questionNo]
    if (quiz && !addQuiz) {
      setQuizInfo({
        ...curr,
        option1: curr ? curr.questions.A.value : "",
        option2: curr ? curr.questions.B.value : "",
        option3: curr ? curr.questions.C.value : "",
        option4: curr ? curr.questions.D.value : "",
        correctOption: curr ? curr.correct_answer.value : "",
        imageUrl: curr ? curr.imageUrl : ""
      })
    }
    else if (addQuiz) {
      setQuizInfo({
        ...curr,
        question: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        correctOption: '',
        imageUrl: ''
      })
    }
  }, [questionNo, quiz, addQuiz, loader])

  // useEffect(() => {
  //   console.log("running again")
  //   if(!quiz?.questions?.length){
  //     fetchQuestions()
  //   }
  // }, [])

  if (!quizIdMatch || !questionIdMatch) return
  if (!quizInfo) return <Loader />
  const questions = quizInfo
  return (
    <div>
      <Sidebar isQuiz={true} />

      <Container fluid={true} style={{ marginTop: "-92px" }}>
        <Breadcrumbs mainTitle={`Question No: ${questionNo}`} />
        <Row className="justify-content-center">
          <Col lg={6}>
            <div
              className="dashboard"
              style={{
                minHeight: "100vh",
                paddingBottom: "55px",
                marginTop: "50px",
              }}
            >
              <Card className="p-4">
                <Form onSubmit={(e) => e.preventDefault()}>
                  <div>
                    {<div className="justify-content-between d-flex">
                      {
                        (isEditable || addQuiz) ? <div className='m-b-10 w-100'>
                          <Label className='show-color'>Question</Label>
                          <Input required type='textarea' value={quizInfo.question} onChange={(e) => setQuizInfo({ ...quizInfo, question: e.target.value })} /> </div>
                          : questions.question ? <P attrPara={{ className: "show-color" }}>
                            <b>{questionNo + 1}{")"}</b>     {questions && questions.question}
                          </P> : ""
                      }
                      {!isEditable && questions.question ? <div style={{ cursor: "pointer" }} className='m-l-10  d-flex align-items-center'>
                        {(isEditable || addQuiz) ?
                          <XCircle onClick={() => setIsEditable(false)} /> :
                          <Edit onClick={() => setIsEditable(true)} />
                        }
                      </div> : ""}
                    </div>}
                    {!isEditable && questions && questions.imageUrl && (
                      <div className="question-image-wrapper">
                        <img
                          className="question-image"
                          src={questions.imageUrl}
                          alt="img"
                        />
                      </div>
                    )}
                    {
                      (isEditable || addQuiz) ? <>
                        <div className='m-b-10'>
                          <Label className='show-color'>Select image source</Label>
                          {quizInfo.imageUrl && <div className="question-image-wrapper cross-container">
                            <img
                              className="question-image"
                              src={quizInfo.imageUrl}
                              alt="img"
                            />
                            <div className='image-cross' onClick={() => setQuizInfo({
                              ...quizInfo,
                              imageUrl: ''
                            })}>
                              <X />
                            </div>
                          </div>}
                          <Input type='file' name='imageUrl' onChange={imageChangeHandler} />
                        </div>
                        <div className='quiz-option'>
                          <div className='option'>A</div>
                          <Input name='option1' required value={quizInfo.option1} placeholder='Option One' onChange={(e) => optionChangeHandler(e.target.value, e.target.name)} />
                        </div>
                        <div className='quiz-option m-t-5'>
                          <div className='option'>B</div>

                          <Input name='option2' required value={quizInfo.option2} placeholder='Option Two' onChange={(e) => optionChangeHandler(e.target.value, e.target.name)} />
                        </div>
                        <div className='quiz-option m-t-5'>
                          <div className='option'>C</div>

                          <Input name='option3' required value={quizInfo.option3} placeholder='Option Three' onChange={(e) => optionChangeHandler(e.target.value, e.target.name)} />
                        </div>
                        <div className='quiz-option m-t-5'>
                          <div className='option'>D</div>

                          <Input name='option4' required value={quizInfo.option4} placeholder='Option Four' onChange={(e) => optionChangeHandler(e.target.value, e.target.name)} />
                        </div>
                        <div className='m-t-10'>
                          <Label className='show-color'>Select correct option</Label>
                          <Select
                            value={{ value: quizInfo.correctOption, label: quizInfo.correctOption }}
                            onChange={(e) => setQuizInfo({ ...quizInfo, correctOption: e.value })}
                            options={[
                              { value: quizInfo.option1, label: quizInfo.option1 },
                              { value: quizInfo.option2, label: quizInfo.option2 },
                              { value: quizInfo.option3, label: quizInfo.option3 },
                              { value: quizInfo.option4, label: quizInfo.option4 }
                            ]}
                            className="js-example-basic-single col-sm-12" />
                        </div>

                      </> : questions.questions ?
                        <>
                          <div style={{ position: "relative", marginBottom: 12 }}>
                            <input
                              type="checkbox"
                              className="check-box checkedColor"

                              onChange={() => { }}
                              checked={
                                questions &&
                                  questions.index === questionNo &&
                                  questions &&
                                  questions.option === questions.questions.A.name
                                  ? true
                                  : false
                              }
                              value="checkedA"
                            />
                            <label
                              className={`option-label 
                                        ${questions &&
                                (questions.questions.A.name ===
                                  questions.correct_answer.name
                                  ? "correct-answer"
                                  : "inncorrect-answer")
                                }`}
                            >
                              {questions.questions.A.value}
                            </label>
                          </div>
                          <div style={{ position: "relative", marginBottom: 12 }}>
                            <input
                              type="checkbox"
                              className="check-box checkedColor"

                              onChange={() => { }}
                              checked={
                                questions &&
                                  questions.index == questionNo &&
                                  questions &&
                                  questions.option == questions.questions.B.name
                                  ? true
                                  : false
                              }
                              value="checkedB"
                            />
                            <label
                              className={`option-label 
                                        ${questions &&
                                (questions.questions.B.name ===
                                  questions.correct_answer.name
                                  ? "correct-answer"
                                  : "inncorrect-answer")
                                }`}
                            >
                              {questions.questions.B.value}
                            </label>
                          </div>
                          <div style={{ position: "relative", marginBottom: 12 }}>
                            <input
                              type="checkbox"
                              className="check-box checkedColor"
                              checked={
                                questions &&
                                  questions.index == questionNo &&
                                  questions &&
                                  questions.option == questions.questions.C.name
                                  ? true
                                  : false
                              }
                              value="checkedC"
                            />
                            <label
                              className={`option-label 
                                        ${questions &&
                                (questions.questions.C.name ===
                                  questions.correct_answer.name
                                  ? "correct-answer"
                                  : "inncorrect-answer")
                                }`}
                            >
                              {questions.questions.C.value}
                            </label>
                          </div>
                          <div style={{ position: "relative", marginBottom: 12 }}>
                            <input
                              type="checkbox"
                              className="check-box checkedColor"

                              onChange={() => { }}
                              checked={
                                questions &&
                                  questions.index == questionNo &&
                                  questions &&
                                  questions.option == questions.questions.D.name
                                  ? true
                                  : false
                              }
                              value="checkedD"
                            />
                            <label
                              className={`option-label 
                                ${questions &&
                                (questions.questions.D.name ===
                                  questions.correct_answer.name
                                  ? "correct-answer"
                                  : "inncorrect-answer")
                                }`}
                            >
                              {questions.questions.D.value}
                            </label>
                          </div>

                        </> : ''
                    }
                  </div>
                  {(quiz?.questions?.length || !quiz?.questions?.length && addQuiz) && <div className='d-flex align-items-center justify-content-between m-t-20'>
                    <Btn attrBtn={{
                      onClick: () => close(),
                      disabled: (isEditable || addQuiz) ? false : questionNo === 0,
                    }}>
                      {(isEditable || addQuiz) ? 'Close' : 'Back'}
                    </Btn>
                    <Btn
                      attrBtn={{
                        color: "primary",
                        disabled: loader,
                        type: addQuiz ? 'submit' : 'btn',
                        onClick: () => update(),
                        disabled: (isEditable || addQuiz) ? false : questionNo === quiz?.questions?.length - 1
                      }}>
                      {loader ? 'Loading...' : addQuiz ? 'Create' : isEditable ? 'Update' : 'Next'}</Btn>
                  </div>}
                </Form>
              </Card>
            </div>
          </Col>
        </Row>
        {cropper.show && <CommonModal
          isOpen={cropper.show}
          bodyClass='screen-modal-form'
          toggler={() => {
            closeImageCropper()
          }}
          successText='Done'
          title='Crop Question Source'
          success={cropComplete}
        >
          <ImagecropperContain imageCanvasRef={imageCanvasRef} url={cropper.url} />
        </CommonModal>}
      </Container >

    </div>
  )
}

export default QuizQuestions